module.exports = __webpack_public_path__ + "img/schulung.2237931e.svg";